export function isEmbedPath(pathname: string) {
  return pathname.startsWith('/embed')
}
